module.exports = __webpack_public_path__ + "static/img/news77_7.cc735d6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news77/news77_7.webp
// module id = r9yq
// module chunks = 0